export default "__VITE_ASSET__158e2b49__"